// src/pages/MyBookingPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MyProperties from "../components/MyProperties";
import MyMessages from "../components/MyMessages";

const MessagesPage = () => {
  return (
    <>
      <Header />
      <MyMessages />
      <Footer />
    </>
  );
};

export default MessagesPage;
